import React from "react";
import { ArrowRightGray, AttentionIcon, CompletedStep, CurrentStep, UnselectedStep } from "../../common/ProjectIcons";

type ConnectionProgressStepProps = {
    stepLabel: string;
    status: 'completed' | 'in-progress' | 'upcoming' | 'attention';
    finalStep: boolean;
}

const ConnectionProgressStep = ({
    stepLabel,
    status,
    finalStep
}: ConnectionProgressStepProps) => {

    const getStepIcon = () => {
        switch (status) {
            case 'attention':
                return <AttentionIcon />
            case 'completed':
                return <CompletedStep />;
            case 'in-progress':
                return <CurrentStep />;
            case 'upcoming':
            default:
                return <UnselectedStep />;
        }
    };

    const getLabelClassName = () => {
        return status === 'in-progress' ? 'text-status-green font-semibold mr-4' : 'mr-4';
    };

    return (
        <div className="bg-white rounded-lg py-2 flex items-center transition-colors duration-300">
            <span className="mr-1.5 mb-1">{getStepIcon()}</span>
            <label className={`${getLabelClassName()} text-off-black transition-colors duration-300`}>{stepLabel}</label>
            {!finalStep && <span className="mr-4"><ArrowRightGray /></span>}
        </div>
    );
};

export default ConnectionProgressStep;